import React, { useEffect, useRef } from 'react';

/**
 * Tek bir diyalog bileşeni: masa popup'ı, opsiyon seçimi ve onay kutuları
 * aynı kabuğu kullanır (iki ayrı modal mantığı er ya da geç ayrışır).
 *
 * Servis hızına göre ayarlandı:
 *  · Esc ve perdeye dokunuş kapatır (elin klavyeye gitmesine gerek yok),
 *  · telefonda alttan tam genişlik açılır (başparmak menzili),
 *  · açılınca ilk düğmeye odaklanır — klavyeli kasada Enter yeterli.
 */
export default function Modal({ title, subtitle, onClose, children, footer, wide = false }) {
  const box = useRef(null);

  useEffect(() => {
    const esc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', esc);
    // Arkadaki sayfa kaymasın: popup açıkken gövde kilitlenir.
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    box.current?.querySelector('button, [href], input, select')?.focus();
    return () => {
      document.removeEventListener('keydown', esc);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div className="modal-wrap" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={wide ? 'modal modal-wide' : 'modal'} role="dialog" aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined} ref={box}>
        <header className="modal-head">
          <div>
            <h2>{title}</h2>
            {subtitle && <p className="muted">{subtitle}</p>}
          </div>
          <button className="modal-x" onClick={onClose} aria-label="×">×</button>
        </header>
        <div className="modal-body">{children}</div>
        {footer && <footer className="modal-foot">{footer}</footer>}
      </div>
    </div>
  );
}
